import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

import {service} from '@/api/api'
import {calendar} from '@/api/google-api'

Vue.use(VueLocalStorage)

const typeMap = {
  "0701": "advance-payment"
}

export default {
  state: {
    dataBusiness: null || JSON.parse(window.localStorage.getItem("dataBusiness")),
    buyConcepts: null,
    myConceptList: null,
    occupationList: null
  },
  getters: {
    listConcepts(state){
      if(state.buyConcepts)
        return state.buyConcepts.map(concept => {
          return {
            ...concept,
            name: concept.category === 'discounts' ? `[DESCUENTO] ${concept.name}` : (concept.alias ? `${concept.name} (${concept.alias})` : concept.name)
          }
        })
      return []
    },
    myConcepts(state){
      if(state.myConceptList)
        return state.myConceptList
      return []
    },
    myConceptsRemunerations(state){
      if(state.myConceptList)
        return state.myConceptList.filter(concept => concept.category !== 'discounts').map(concept => {
          return {
            ...concept,
            name: concept.category === 'discounts' ? `[DESCUENTO] ${concept.name}` : (concept.alias ? `${concept.name} (${concept.alias})` : concept.name)
          }
        })
      return []
    },
    myConceptsDiscounts(state){
      if(state.myConceptList)
        return state.myConceptList.filter(concept => concept.category === 'discounts').map(concept => {
          return {
            ...concept, type: typeMap[concept.code]
          }
        })
      return []
    },
    getDataBusiness(state){
      return state.dataBusiness
    }
  },
  mutations: {
    ['SET__DATABUSINESS'](state,payload){
      state.dataBusiness = payload,
      state.myConceptList = payload.itdConcepts
    },
    ['SET__CONCEPTS'](state,payload){
      state.buyConcepts = payload
    }
  },
  actions: {
    //obtine conceptos d pago
    async getItdConcepts({commit}){
      let res = await service.getItdConcepts()
      if(res.status == 200)
        commit('SET__CONCEPTS',res.data)
      return res
    },
    async getDetailBusiness({commit,rootState}, payload){
      let res = await service.getDetailBusiness(payload)
      if(res.status == 200)
        commit('SET__DATABUSINESS',res.data)
        window.localStorage.setItem("dataBusiness",JSON.stringify(res.data))
      return res
    },

    //agregar concept de pago
    async addConcept({rootState},payload){
      let res = await service.addConcept({
        id: rootState.business.businessId,
        body: payload
      })
      return res
    },

    //unlink concepto de pago
    async unlinkConcept({rootState},payload){
      let res = await service.unlinkConcept({
        id: rootState.business.businessId,
        body: payload
      })
      return res
    },

    //obtieneindo los empleos
    async getOccupations({},payload){
      let res = await service.getOccupations(payload)
      return res
    },

    displayGaaa({rootState}){
      console.log(rootState.business.businessId)
    },
    async getHolidays({}){
      let res = await calendar.listHolidays()
      return res
    }
  }
}